import { app } from '../../../../app';
import { Controller } from './manage-group.controller';

app.component('companyUserDirectoriesManageGroup', {
    bindings: {group: '<'},
    controller: Controller,
    templateUrl: require('./manage-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/manage-group.component.js